import { render } from "./VueSelect.vue?vue&type=template&id=7abe75c3"
import script from "./VueSelect.vue?vue&type=script&lang=ts"
export * from "./VueSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script